import React from 'react'
import { ButtonWithIcon } from '@mobi/component-library/Common/Buttons'
import { ContentHeaderStyled } from './RaceEventsHeader.styles'
import { Grid, GridCell } from '@mobi/component-library/Common/Grid'
import { Icon } from '@mobi/component-library/Common/Icon'
import { appHistory } from '@core/Utils/routing/history'
import { AppRoutes } from '@core/AppRoutes'
import { Link } from 'react-router'

interface RaceEventsHeaderProps {
  title: string
  backUrl: string
}

const RaceEventsHeader = ({ title, backUrl }: RaceEventsHeaderProps): JSX.Element => {
  return (
    <div>
      <ContentHeaderStyled>
        <Grid>
          <GridCell width='2rem' valign='middle'>
            <ButtonWithIcon
              onClick={() => appHistory.push(AppRoutes.Home)}
              icon={<Icon type='house' title='Home' />}
              color='light'
            />
          </GridCell>
          <GridCell valign='middle' align='center'>
            <h2>
              <Link to={`/${backUrl}`} data-tid-page-title=''>
                {title}
              </Link>
            </h2>
          </GridCell>
          <GridCell width='2rem' valign='middle' />
        </Grid>
      </ContentHeaderStyled>
    </div>
  )
}

export default RaceEventsHeader
